<script>
import GmbAttributeChip from "@/components/FacilityDetails/GmbAttributes/GmbAttributeChip";
import { mapActions } from "vuex";

export default {
  components: {
    GmbAttributeChip
  },
  props: {
    attributeId: {
      type: String,
      required: true
    },
    deleteMode: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      attribute: null,
      selectedValue: null,
      selectedValues: []
    };
  },
  async mounted() {
    this.attribute = await this.findAttribute(this.attributeId);
    this.selectedValue = this.attribute.value;
  },
  methods: {
    ...mapActions({
      findAttribute: "attributes/findAttribute",
      updateAttribute: "attributes/updateAttribute"
    }),
    selectValue(value) {
      this.selectedValue = value;
      this.updateAttribute({ attributeId: this.attributeId, value });
    },
    onSelect(value) {
      this.$emit("onSelect", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.gmb-attribute-item {
  &.group {
    border-radius: 12px;
    background: $attribute-group-bg-color;
    padding: 14px $spacing;
    margin-bottom: $spacing / 2;
    margin-top: $spacing / 2;
  }

  .attribute-name {
    @include font-size(14px);
    font-weight: 600;
    line-height: 17px;
    color: $grey-darker;
    margin-bottom: $spacing;
  }

  .chip-group {
    display: flex;
    flex-flow: row wrap;
  }
}
</style>
